import cx from 'classnames';
import styles from './bob-banner-white.module.scss';
import { FC, PropsWithChildren } from 'react';

interface CSRBannerWhiteProps {
    variant?: 'default' | 'small',
}

export const CSRBannerStripWhite: FC<PropsWithChildren<CSRBannerWhiteProps>> =
    ({ variant = 'default', children }) => {
        return (
            <div id="CSRBannerStrip"
                className={cx({
                    [styles['CSRBannerStrip__hidden_height']]: variant === 'default',
                    [styles['CSRBannerStrip__small_height']]: variant === 'small'
                })}
            >
                <div
                    className={cx(
                        'd-flex',
                        'align-items-center',
                        'justify-content-center',
                        'py-2',
                        styles['CSRBannerStrip']
                    )}
                    style={{ gap: '16px' }}
                >
                    {children}
                </div>
            </div>
        );
    };

export default CSRBannerStripWhite;
